function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#1e201d",
  d: "M21.205 5.007a1.112 1.112 0 00-1.587 0 1.12 1.12 0 000 1.571l8.047 8.047H1.111A1.106 1.106 0 000 15.737c0 .619.492 1.127 1.111 1.127h26.554l-8.047 8.032c-.429.444-.429 1.159 0 1.587a1.112 1.112 0 001.587 0l9.952-9.952a1.093 1.093 0 000-1.571l-9.952-9.953z"
});

function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 31.49 31.49"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMzEuNDkgMzEuNDkiPgogIDxwYXRoIGZpbGw9IiMxZTIwMWQiIGQ9Ik0yMS4yMDUgNS4wMDdhMS4xMTIgMS4xMTIgMCAwMC0xLjU4NyAwIDEuMTIgMS4xMiAwIDAwMCAxLjU3MWw4LjA0NyA4LjA0N0gxLjExMUExLjEwNiAxLjEwNiAwIDAwMCAxNS43MzdjMCAuNjE5LjQ5MiAxLjEyNyAxLjExMSAxLjEyN2gyNi41NTRsLTguMDQ3IDguMDMyYy0uNDI5LjQ0NC0uNDI5IDEuMTU5IDAgMS41ODdhMS4xMTIgMS4xMTIgMCAwMDEuNTg3IDBsOS45NTItOS45NTJhMS4wOTMgMS4wOTMgMCAwMDAtMS41NzFsLTkuOTUyLTkuOTUzeiIvPgo8L3N2Zz4K";
export { SvgArrowRight as ReactComponent };